<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="role" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="角色名称">
              <el-input v-model="role.rolename" :maxlength="20" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vgtree ref="xTree" :list="list" tableheight="700" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needRowNum="true" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
              @getxTree="getxTree">
      </vgtree>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree'
  export default {
    name: "roleAuthReport",
    data () {
      return {
        role: this.$route.params.form,
        type: Number(this.$route.params.type),
        btnLoading: false,
        menuList: [],
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80,treeNode:'true'},
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'reportname', fieldtype: 'C', title: '报表名称',calculExpr:'',addNewRowFlg: false}
        ],
      }
    },
    activated () {
      this.init()
      this.getPageList()
    },
    watch: {
    },
    filters: {
    },
    components: {vgtree},
    methods: {
      async init() {
        this.role = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.menuList = []
        this.list = []
      },
      async save () {
        let selectRecords = this.$refs.xTree.$refs.xTree.getSelectRecords()
        let model = {
          insertRecords:selectRecords,
          roleid: this.role.roleid,
          comid: this.$store.getters.loginUser.usercomid
        }
        this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/xtgl/role/saveRoleReportByRole',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getxTree(xtree) {
        this.xTree = xtree
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/role/getAuthReportTree',
          params: {comid: this.$store.getters.loginUser.usercomid,roleid: this.role.roleid}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'roleIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
